import { createActions } from 'redux-actions';
import keyMirror from 'key-mirror';

export const constants = keyMirror({
    // Session management
    START_SESSION_REQUEST: null,
    START_SESSION_SUCCESS: null,
    START_SESSION_FAILURE: null,

    END_SESSION_REQUEST: null,
    END_SESSION_SUCCESS: null,
    END_SESSION_FAILURE: null,

    SEND_HEARTBEAT_REQUEST: null,
    SEND_HEARTBEAT_SUCCESS: null,
    SEND_HEARTBEAT_FAILURE: null,

    // Page views
    TRACK_PAGE_VIEW_REQUEST: null,
    TRACK_PAGE_VIEW_SUCCESS: null,
    TRACK_PAGE_VIEW_FAILURE: null,

    SEND_PAGE_VIEWS_BATCH_REQUEST: null,
    SEND_PAGE_VIEWS_BATCH_SUCCESS: null,
    SEND_PAGE_VIEWS_BATCH_FAILURE: null,

    // Events
    TRACK_EVENT_REQUEST: null,
    TRACK_EVENT_SUCCESS: null,
    TRACK_EVENT_FAILURE: null,

    SEND_EVENTS_BATCH_REQUEST: null,
    SEND_EVENTS_BATCH_SUCCESS: null,
    SEND_EVENTS_BATCH_FAILURE: null,

    // Queue management
    QUEUE_PAGE_VIEW: null,
    QUEUE_EVENT: null,
    CLEAR_PAGE_VIEW_QUEUE: null,
    CLEAR_EVENT_QUEUE: null,

    // Current page tracking
    SET_CURRENT_PAGE: null,
    CLEAR_CURRENT_PAGE: null,

    // Session state
    SET_SESSION_ID: null,
    CLEAR_SESSION: null,
});

export const {
    // Session management
    startSessionRequest,
    startSessionSuccess,
    startSessionFailure,

    endSessionRequest,
    endSessionSuccess,
    endSessionFailure,

    sendHeartbeatRequest,
    sendHeartbeatSuccess,
    sendHeartbeatFailure,

    // Page views
    trackPageViewRequest,
    trackPageViewSuccess,
    trackPageViewFailure,

    sendPageViewsBatchRequest,
    sendPageViewsBatchSuccess,
    sendPageViewsBatchFailure,

    // Events
    trackEventRequest,
    trackEventSuccess,
    trackEventFailure,

    sendEventsBatchRequest,
    sendEventsBatchSuccess,
    sendEventsBatchFailure,

    // Queue management
    queuePageView,
    queueEvent,
    clearPageViewQueue,
    clearEventQueue,

    // Current page tracking
    setCurrentPage,
    clearCurrentPage,

    // Session state
    setSessionId,
    clearSession,
} = createActions(
    // Session management
    constants.START_SESSION_REQUEST,
    constants.START_SESSION_SUCCESS,
    constants.START_SESSION_FAILURE,

    constants.END_SESSION_REQUEST,
    constants.END_SESSION_SUCCESS,
    constants.END_SESSION_FAILURE,

    constants.SEND_HEARTBEAT_REQUEST,
    constants.SEND_HEARTBEAT_SUCCESS,
    constants.SEND_HEARTBEAT_FAILURE,

    // Page views
    constants.TRACK_PAGE_VIEW_REQUEST,
    constants.TRACK_PAGE_VIEW_SUCCESS,
    constants.TRACK_PAGE_VIEW_FAILURE,

    constants.SEND_PAGE_VIEWS_BATCH_REQUEST,
    constants.SEND_PAGE_VIEWS_BATCH_SUCCESS,
    constants.SEND_PAGE_VIEWS_BATCH_FAILURE,

    // Events
    constants.TRACK_EVENT_REQUEST,
    constants.TRACK_EVENT_SUCCESS,
    constants.TRACK_EVENT_FAILURE,

    constants.SEND_EVENTS_BATCH_REQUEST,
    constants.SEND_EVENTS_BATCH_SUCCESS,
    constants.SEND_EVENTS_BATCH_FAILURE,

    // Queue management
    constants.QUEUE_PAGE_VIEW,
    constants.QUEUE_EVENT,
    constants.CLEAR_PAGE_VIEW_QUEUE,
    constants.CLEAR_EVENT_QUEUE,

    // Current page tracking
    constants.SET_CURRENT_PAGE,
    constants.CLEAR_CURRENT_PAGE,

    // Session state
    constants.SET_SESSION_ID,
    constants.CLEAR_SESSION,
);
